/* eslint-disable max-len */
/* eslint-disable prefer-template */
import React from 'react';
import './style.css';
import { Button } from '@material-ui/core';

export default function LinkExpirePage()
{
	return (

		<div className='flexCol aCntr jCntr sessionEnd'>
			<div style={{ width: '60%', height: '320px' }} className='flexAutoCol aCntr jCntr whiteBg pdngMD brdrRadiusSM gap16'>
				<img style={{ width: '120px', height: '120px' }} src='images/linkExp.svg' alt='LinkExperired'/>
				<span>This link is no longer valid. Please contact your webinar organizer.</span>
				<Button color='primary' variant='contained' disableElevation size='small' onClick={(e) =>
				{
					e.preventDefault();
					window.location.href = import.meta.env.VITE_config;
				}}
				>Go Home Page</Button>
			</div>
		</div>
	);
}